import { GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_THREEPOINTS, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_PENALITE, 
    GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_TRANSFORMATION, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_HANDBALL_SHOOTOUT} from "../gameFact/constants.js"

import essai_reussi from '../../../images/live/icones/live_essai.png'
import drop_reussi from '../../../images/live/icones/live_dropreussi.png'
import transformation_reussi from '../../../images/live/icones/live_transformationreussie.png'
import penalite_reussi from '../../../images/live/icones/live_penalitereussie.png'
import but_reussi from '../../../images/live/icones/live_but.png'
import penalty_reussi from '../../../images/live/icones/live_penaltyreussi.png'

export function scoreResolver(match){
    if(!match.gameFacts || !match.homeTeam)
        return

    let homeTeamId = match.homeTeam._id
    let awayTeamId = match.awayTeam._id

    let homeScoreCalcul = 0
    let awayScoreCalcul = 0

    let homePlayerScoreCalcul = []
    let awayPlayerScoreCalcul = []



    if(match.discipline === 'rugby'){
        // On récupère tous les gameFact de type GAMEFACT_ESSAI
        const gameFactEssais = match.gameFacts.filter(gf => gf.type === GAME_FACT_ESSAI)
        const gameFactTransformation = match.gameFacts.filter(gf => gf.type === GAME_FACT_TRANSFORMATION)
        const gameFactDrop = match.gameFacts.filter(gf => gf.type === GAME_FACT_DROP)
        const gameFactPenality = match.gameFacts.filter(gf => gf.type === GAME_FACT_PENALITE)

        gameFactEssais.forEach(gf => {
            const {team, buteur, timer} = gf.detail

            let scoreToAdd = buteur === 'edp' ? 7 : 5

            if(team === homeTeamId){
                homeScoreCalcul+=scoreToAdd
                homePlayerScoreCalcul.push({player : buteur, timer, icone : essai_reussi})
            }else if(team === awayTeamId){
                awayScoreCalcul+=scoreToAdd
                awayPlayerScoreCalcul.push({player : buteur, timer, icone : essai_reussi})
            }  
        })

        gameFactTransformation.forEach(gf => {
            const {transformSucced, team, transformer, timer} = gf.detail

            let scoreToAdd = 2

            if(transformSucced){
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player : transformer, timer, icone : transformation_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player : transformer, timer, icone : transformation_reussi})
                }
            }
        })

        gameFactDrop.forEach(gf => {
            const {dropSucced, team, droper, timer} = gf.detail

            let scoreToAdd = 3

            if(dropSucced){
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player : droper, timer, icone : drop_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player : droper, timer, icone : drop_reussi})
                }
            }
        })

        gameFactPenality.forEach(gf => {
            const {penalitySucced, team, penaliter, timer} = gf.detail

            let scoreToAdd = 3

            if(penalitySucced){
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player : penaliter, timer, icone : penalite_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player : penaliter, timer, icone : penalite_reussi})
                }

            }
        })
    }else if(match.discipline === 'soccer'){
        // On récupère tous les gameFact de type GAMEFACT_ESSAI
        const gameFactBut = match.gameFacts.filter(gf => gf.type === GAME_FACT_SOCCER_BUT)
        const gameFactPenalty = match.gameFacts.filter(gf => gf.type === GAME_FACT_SOCCER_PENALTY)

        gameFactBut.forEach(gf => {
            const {butSucced, team, buteur, timer} = gf.detail

            let scoreToAdd = 1

            if(butSucced){
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player : buteur, timer, icone : but_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player : buteur, timer, icone : but_reussi})
                }
            }
        })

        gameFactPenalty.forEach(gf => {
            const {butSucced, team, buteur, timer} = gf.detail

            let scoreToAdd = 1

            if(butSucced){
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player : buteur, timer, icone : penalty_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player : buteur, timer, icone : penalty_reussi})
                }
            }
        })
    }else if(match.discipline === 'basket'){
        // On récupère tous les gameFact de type GAMEFACT_ESSAI
        const gameFactTwoPoints = match.gameFacts.filter(gf => gf.type === GAME_FACT_BASKET_TWOPOINTS)
        const gameFactThreePoints = match.gameFacts.filter(gf => gf.type === GAME_FACT_BASKET_THREEPOINTS)
        const gameFactFreeThrow = match.gameFacts.filter(gf => gf.type === GAME_FACT_BASKET_FREETHROW)

        gameFactTwoPoints.forEach(gf => {
            const {team, player, timer, isSucceed} = gf.detail
         
            let scoreToAdd = 2
            if(isSucceed)
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }
        })

        gameFactThreePoints.forEach(gf => {
            const {team, player, timer, isSucceed} = gf.detail

            let scoreToAdd = 3
            if(isSucceed)
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }
        })

        gameFactFreeThrow.forEach(gf => {
            const {team, player, timer, isSucceed} = gf.detail

            let scoreToAdd = 1

            if(isSucceed)
                if(team === homeTeamId){
                    homeScoreCalcul+=scoreToAdd
                    homePlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }else if(team === awayTeamId){
                    awayScoreCalcul+=scoreToAdd
                    awayPlayerScoreCalcul.push({player:player, timer, icone : but_reussi})
                }
        })


    }else if(match.discipline === 'handball'){

        const processGameFact = (gf, homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul, awayPlayerScoreCalcul) => {
            const { butSucced, penalitySucced, team, buteur, penaliter, timer } = gf.detail;
            const scoreToAdd = 1;

            if (butSucced || penalitySucced) {
                if (team === homeTeamId) {
                    homeScoreCalcul += scoreToAdd;
                    homePlayerScoreCalcul.push({ player: buteur ? buteur : penaliter, timer, icone: but_reussi });
                } else if (team === awayTeamId) {
                    awayScoreCalcul += scoreToAdd;
                    awayPlayerScoreCalcul.push({ player: buteur ? buteur : penaliter, timer, icone: but_reussi });
                }
            }
            return { homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul, awayPlayerScoreCalcul };
        };

        // GF goals & penalty & shootouts
        const allGameFacts = [...match.gameFacts.filter(gf => gf.type === GAME_FACT_HANDBALL_GOAL || gf.type === GAME_FACT_HANDBALL_PENALTY)];
        
        allGameFacts.forEach(gf => {
            ({ homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul, awayPlayerScoreCalcul } = 
                processGameFact(gf, homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul, awayPlayerScoreCalcul));
        });


    }else{
        console.error('Discipline non-reconnue pour l\'auto-scoring');
    }

    return [homeScoreCalcul, awayScoreCalcul, homePlayerScoreCalcul.sort(sortByTimer), awayPlayerScoreCalcul.sort(sortByTimer)]
}

const sortByTimer = (a, b) => {
    return a.timer - b.timer
}